const TrustedFilter = function ($sce) {
    return function (text) {
        return $sce.trustAsHtml(text);
    };
};


export default TrustedFilter;